import styled from "styled-components";

export const ExternalLabel = styled.div`
  > div > div {
    color: var(--neutrals-text, var(--Color-neutral-700, #100a27));
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 18px;
    margin-top: 16px;
    display: block;
  }
`;
